// FlightSection — Presentational composition of the flight action buttons (when
// neither sub-form is open), the FlightSearch/FlightLookup wrappers, and the
// "Added Flights" list of FlightListItem rows.
//
// Extracted VERBATIM from `components/ManualTripCreator.js` (behavior-preserving
// refactor, issue #240). Render-only, wrapped in React.memo. Markup, styles,
// text, and conditional render guards are identical to the source. Props match
// the source's `FlightSection` exactly.
//
// Validates: Requirements 3.3, 3.4, 1.2, 1.6

import React from 'react';
import FlightLookup from '../../FlightLookup';
import FlightSearch from '../../FlightSearch';
import { FlightActionButtons } from './FlightActionButtons';
import { FlightListItem } from './FlightListItem';

export const FlightSection = React.memo(function FlightSection({
  showFlightLookup, showFlightSearch, isCreating, flights,
  formData, onSearchClick, onLookupClick, onFlightFound,
  onCancelSearch, onCancelLookup, onRemoveFlight,
  getDefaultDepartureAirport, getDefaultArrivalAirport
}) {
  return (
    <>
      {!showFlightLookup && !showFlightSearch && (
        <FlightActionButtons
          isCreating={isCreating}
          onSearchClick={onSearchClick}
          onLookupClick={onLookupClick}
        />
      )}

      {showFlightSearch && (
        <div style={{ marginBottom: '24px' }}>
          <FlightSearch
            onFlightFound={onFlightFound}
            onCancel={onCancelSearch}
            defaultDate={formData.startDate || undefined}
            defaultDepartureAirport={getDefaultDepartureAirport()}
            defaultArrivalAirport={getDefaultArrivalAirport()}
          />
        </div>
      )}

      {showFlightLookup && (
        <div style={{ marginBottom: '24px' }}>
          <FlightLookup
            onFlightFound={onFlightFound}
            onCancel={onCancelLookup}
            defaultDate={formData.startDate || undefined}
            defaultDepartureAirport={getDefaultDepartureAirport()}
            defaultArrivalAirport={getDefaultArrivalAirport()}
          />
        </div>
      )}

      {flights.length > 0 && (
        <div style={{ marginBottom: '24px' }}>
          <h4 style={{
            fontSize: '16px',
            fontWeight: '600',
            color: '#374151',
            marginBottom: '12px'
          }}>
            Added Flights ({flights.length})
          </h4>
          <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
            {flights.map((flight, index) => (
              <FlightListItem
                key={index}
                flight={flight}
                index={index}
                isCreating={isCreating}
                onRemove={onRemoveFlight}
              />
            ))}
          </div>
        </div>
      )}
    </>
  );
});

export default FlightSection;
